import OnePlatformCommonActions from "@frameworks/web/redux/actions/common/commonActions";
import { ERROR_MSG, FAMILY_DETAILS, SEARCH, SELECTED_MEMBER, STOP_FAM_API_CALL, } from "@frameworks/web/redux/interfaces/Reports/iFamilyTagging";
class FamilyDetailsActions extends OnePlatformCommonActions {
    setFamilyError(message, type) {
        this.dispatch({
            type: ERROR_MSG,
            payload: { message },
            reducerName: type,
        });
    }
    setStopFamilyAPICall(stopFamilyAPiCall, type) {
        this.dispatch({
            type: STOP_FAM_API_CALL,
            payload: { stopFamilyAPiCall },
            reducerName: type,
        });
    }
    setSelectedMember(selectedMember, type) {
        this.dispatch({
            type: SELECTED_MEMBER,
            payload: { selectedMember },
            reducerName: type,
        });
    }
    getFamilyDetails(familyDetails, type) {
        this.dispatch({
            type: FAMILY_DETAILS,
            payload: { familyDetails },
            reducerName: type,
        });
    }
    setSearchData(search, type) {
        this.dispatch({
            type: SEARCH,
            payload: { search },
            reducerName: type,
        });
    }
}
export default FamilyDetailsActions;
